const NewsLetterSubsription = () => {
    return (
        <>
            <h1>NewsLetterSubsription</h1>
        </>
    );
};

export default NewsLetterSubsription;